import React from 'react';
import PropTypes from 'prop-types';
import { Responsive, Menu } from 'semantic-ui-react';
import i18next from 'i18next';
import AppContainer from '../app-container/AppContainer';

import './SubContainer.scss';

const MIN_WIDTH = 768;

const SubContainer = ({ children, renderPicker, renderMenuItems, menuItemsCount, ...props }) => {    
    // if (!renderPicker && !renderMenuItems) {
    //     return (
    //         <AppContainer {...props}>
    //             {children}
    //         </AppContainer>
    //     );
    // }

    return (
        <AppContainer {...props}>
            <div className="sub-container">
                {children}
                <Responsive maxWidth={MIN_WIDTH - 1} style={{ height: 60 }} />
            </div>

            <Responsive minWidth={MIN_WIDTH} as={Menu} vertical borderless fixed="left" className="side-nav-menu">
                <Menu.Item style={{ padding: 0 }}>
                    {renderPicker(true)}
                </Menu.Item>

                {renderMenuItems(false)}
            </Responsive>

            <Responsive maxWidth={MIN_WIDTH - 1}>
                <Menu fixed="top" borderless className="mini-nav-menu" widths={menuItemsCount || 8}>
                    {renderMenuItems(true)}
                </Menu>
                <Menu fixed="top" widths={1}>
                    {renderPicker()}
                </Menu>
            </Responsive>
        </AppContainer>
    );
};

SubContainer.propTypes = {
    children: PropTypes.any,
    
    match: PropTypes.object
};

export default SubContainer;
